import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { EventTypeCategory, IEventEventType } from "../../models/event/eventEventType";
import { EventEventTypeSummaryList } from "./eventEventTypeSummaryList";
import { EventTypeNode, IEventTypeNode } from "../../models/event/eventTypeNode";
import { FormRow } from "../framework/formRow";

//EventEditIdentificationSummary
interface IEventEditIdentificationSummaryProp {
    eventTypeNodes: IEventTypeNode[];
    eventTypeBNodes: IEventTypeNode[];
    eventTypeCNodes: IEventTypeNode[];
    eventEventTypes: IEventEventType[];
    directCosts: number;
    indirectCosts: number;
    amount: number;
    identificationDetails: string;
}

export class EventEditIdentificationSummary extends React.Component<IEventEditIdentificationSummaryProp, {}> {
    render() {
        const props = this.props;
        const eventTypeNodes = EventTypeNode.getEventTypeNodesFromNodesByIds(props.eventTypeNodes, props.eventEventTypes.filter(i => i.eventTypeCategory === EventTypeCategory.A).map(i => i.eventTypeId));
        const eventTypeBNodes = EventTypeNode.getEventTypeNodesFromNodesByIds(props.eventTypeBNodes, props.eventEventTypes.filter(i => i.eventTypeCategory === EventTypeCategory.B).map(i => i.eventTypeId));
        const eventTypeCNodes = EventTypeNode.getEventTypeNodesFromNodesByIds(props.eventTypeCNodes, props.eventEventTypes.filter(i => i.eventTypeCategory === EventTypeCategory.C).map(i => i.eventTypeId));
        return (
            <div className="summarySection">
                {eventTypeNodes.length > 0 &&
                    <div className="row">
                        <div className="col-12">
                            <EventEventTypeSummaryList
                                title={Translations.EventTypes}
                                eventTypeNodes={eventTypeNodes} />
                        </div>
                    </div>}
                {eventTypeBNodes.length > 0 &&
                    <div className="row">
                        <div className="col-12">
                            <EventEventTypeSummaryList
                                title={Translations.EventTypeBs}
                                eventTypeNodes={eventTypeBNodes} />
                        </div>
                    </div>}
                {eventTypeCNodes.length > 0 &&
                    <div className="row">
                        <div className="col-12">
                            <EventEventTypeSummaryList
                                title={Translations.EventTypeCs}
                                eventTypeNodes={eventTypeCNodes} />
                        </div>
                    </div>
                }
                <FormRow
                    label={Translations.DirectCosts}
                >
                    <div>{props.directCosts.toLocaleFixed(2)}</div>
                </FormRow>
                <FormRow
                    label={Translations.IndirectCosts}
                >
                    <div>{props.indirectCosts.toLocaleFixed(2)}</div>
                </FormRow>
                <FormRow
                    label={Translations.Amount}
                >
                    <div>{props.amount.toLocaleFixed(2)}</div>
                </FormRow>
                <FormRow
                    label={Translations.IdentificationDetails}
                >
                    <div className="preWrap">{props.identificationDetails}</div>
                </FormRow>
            </div>
        );
    }
}
